"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTotalFeeAmount = void 0;
const utils_1 = require("../../utils");
/**
 * Calculates the total fee amount for a transaction, considering both nominal fees and fee coverage options.
 *
 * @param {Object} params - Parameters for the total fee calculation.
 * @param {number} params.transactionAmount - The original transaction amount.
 * @param {ActualPayPalFeeStructure} params.actualFeeStructure - The actual PayPal fee structure applied to the transaction.
 * @param {number} params.nominalProviderFeeAmount - The nominal fee amount charged by PayPal.
 * @param {number} params.nominalApplicationFeeAmount - The nominal application fee amount.
 * @param {boolean} params.coverFees - Indicates whether the user has opted to cover the transaction fees (Checkbox is ticked on the /Donate screen).
 * @returns {number} The total fee amount, rounded to two decimal places.
 */
const calculateTotalFeeAmount = ({ transactionAmount, actualFeeStructure, nominalProviderFeeAmount, nominalApplicationFeeAmount, coverFees, }) => {
    // Calculate the sum of nominal provider and application fees
    const nominalTotalFee = nominalProviderFeeAmount + nominalApplicationFeeAmount;
    // If the user is covering fees, calculate the minimum amount needed to cover all fees
    const minimumFeeCoverage = coverFees
        ? (0, utils_1.minimalFeeAmountToCoverFees)({
            netAmount: transactionAmount,
            fees: {
                relative: actualFeeStructure.relativeFee,
                fixed: actualFeeStructure.fixedFee,
            },
        })
        : 0;
    // Choose the larger of nominal total fee and minimum fee coverage
    const adjustedTotalFee = Math.max(nominalTotalFee, minimumFeeCoverage);
    return (0, utils_1.roundNumber)(adjustedTotalFee);
};
exports.calculateTotalFeeAmount = calculateTotalFeeAmount;
//# sourceMappingURL=calculateTotalFeeAmount.js.map